import cn from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import IconChevronUp from 'editor/src/component/Icon/IconChevronUp';
import IconSettings from 'editor/src/component/Icon/IconSettings';

import styles from './index.module.scss';

interface Props {
  children: React.ReactNode;
}

/**
 * Collapses the personalization "Type" and "Customer Settings" sections behind a
 * single gear toggle. Collapsed by default so the panel stays compact — the user
 * expands it only when they need to change personalization type or customer
 * settings.
 */
function PersonalizationSettingsMenu({ children }: Props) {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className={cn(styles.container, 'mb-2')}>
      <button
        type="button"
        className={cn(styles.trigger, 'cy-personalization-settings-toggle')}
        onClick={() => setCollapsed((value) => !value)}
        aria-expanded={!collapsed}
      >
        <IconSettings className={styles.gearIcon} />
        <span className={styles.label}>{t('editor-settings')}</span>
        <IconChevronUp
          className={cn(styles.chevron, {
            [styles.chevronCollapsed]: collapsed,
          })}
        />
      </button>
      {!collapsed && <div className={styles.content}>{children}</div>}
    </div>
  );
}

export default React.memo(PersonalizationSettingsMenu);
